import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconExplosion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"explosion, boom, bang, pop"} maskId="square-filled-radius-0-stroke-1-IconExplosion"><path d="M12.0019 1.4082L9.60449 6.06154L2.35138 2.34943L6.06349 9.60254L1.41016 11.9999L6.13059 14.4319L4.5124 19.4894L9.56992 17.8712L12.0019 22.5917L14.3993 17.9383L21.6524 21.6504L17.9403 14.3973L22.5936 11.9999L17.8732 9.56796L19.4914 4.51045L14.4339 6.12864L12.0019 1.4082Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconExplosion;
